import { getRequest, postRequest, deleteRequest } from "./api.request";

const CONSULTATION_PATH = "/consultation/v1";

// consultation

export const getConsultationByIdApi = async (params) =>
  await getRequest(`${CONSULTATION_PATH}/${params?.id}`);
export const geBedTransferApprovalApi = async (params) =>
  await getRequest(`${CONSULTATION_PATH}/bed-transfers`, params);
export const geBedHistoryByVisitIdApi = async (params) =>
  await getRequest(
    `${CONSULTATION_PATH}/bed-history/${params?.visitId}`,
    params
  );
export const geUnitTransferByVisitIdApi = async (params) =>
  await getRequest(
    `${CONSULTATION_PATH}/unit-transfers/${params?.visitId}`,
    params
  );
export const gePatientVisitByVisitIdApi = async (params) =>
  await getRequest(
    `${CONSULTATION_PATH}/patient/${params?.patientId}/visits`,
    params
  );

export const createConsultationApi = async (body) =>
  await postRequest(CONSULTATION_PATH, body);

export const checkFollowUpEligibilityApi = async (body) =>
  await postRequest("/consultation/v1/check-followup-eligibility", body);

export const createConsultationServicesApi = async (body) =>
  await postRequest(`${CONSULTATION_PATH}/addServices`, body);

export const createConsultationUnitTransfersApi = async (body) =>
  await postRequest(`${CONSULTATION_PATH}/unit-transfers`, body);

export const getConsultationBedTransfersApi = async (params) =>
  await getRequest(`${CONSULTATION_PATH}/bed-transfers`, params);

export const createConsultationBedTransfersApi = async (body) =>
  await postRequest(`${CONSULTATION_PATH}/bed-transfers`, body);

export const addDischargeSummaryByVisitIdApi = async (visitId, body) =>
  await postRequest(
    `${CONSULTATION_PATH}/${visitId}/add-discharge-summary`,
    body
  );
export const createConsultationBedTransfersByTrackingIdApi = async (
  trackingId,
  body
) =>
  await postRequest(
    `${CONSULTATION_PATH}/bed-transfers/${trackingId}/action`,
    body
  );

export const addDoctorNotesByVisitIdApi = async (visitId, body) =>
  await postRequest(`${CONSULTATION_PATH}/${visitId}/add-doctor-notes`, body);
export const addSurgeryProcedureByVisitIdApi = async (visitId, body) =>
  await postRequest(
    `${CONSULTATION_PATH}/${visitId}/add-surgery-procedure`,
    body
  );
export const addDoctorVisitByVisitIdApi = async (visitId, body) =>
  await postRequest(`${CONSULTATION_PATH}/${visitId}/add-doctor-visit`, body);
export const addInitiateDischargeByVisitIdApi = async (visitId, body) =>
  await postRequest(`${CONSULTATION_PATH}/${visitId}/initiate-discharge`, body);
export const confirmDischargeByVisitIdApi = async (visitId, body) =>
  await postRequest(`${CONSULTATION_PATH}/${visitId}/confirm-discharge`, body);
export const bedDislocationByVisitIdApi = async (visitId, body) =>
  await postRequest(`${CONSULTATION_PATH}/${visitId}/bed-dislocation`, body);
export const addServicesToIPDApi = async (body) =>
  await postRequest(
    `${CONSULTATION_PATH}/addServicesToIPD`,
    body
  );

export const getPatientDetailsByVisitIdApi = async (params) =>
  await getRequest(`${CONSULTATION_PATH}/${params?.visitId}/patient-details`);

export const deleteConsultationByIdApi = async (id) =>
  await deleteRequest(`${CONSULTATION_PATH}/${id}`);